import type { SVGProps } from 'react'

const SvgTag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 30 30"
    {...props}
  >
    <title>Tag</title>
    <path d="M23 3h-6a2 2 0 0 0-1.414.586l-12 12a2 2 0 0 0 0 2.828l8 8a2 2 0 0 0 2.828 0l12-12A2 2 0 0 0 27 13V7a4 4 0 0 0-4-4m0 6a2 2 0 1 1-.001-3.999A2 2 0 0 1 23 9" />
  </svg>
)
export default SvgTag
